import {memo} from "react";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
} from "chart.js";
import {Line} from "react-chartjs-2";
import {numberFormat} from "~/utils";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

/**
 * Biểu đồ xu hướng doanh thu theo tháng cho Dashboard CEO.
 * Dữ liệu lấy từ dashboardApi.ceoRevenueTrend(): { labels[], revenue[], plus[] }.
 */
function RevenueTrendChart({
	data,
	loading = false,
	title = 'Xu hướng doanh thu',
	gradient = 'linear-gradient(135deg, #0369a1 0%, #0284c7 60%, #38bdf8 100%)',
}) {

	const labels = data?.labels || [];

	const chartData = {
		labels,
		datasets: [
			{
				label: 'Doanh thu',
				data: data?.revenue || [],
				borderColor: '#0284c7',
				backgroundColor: 'rgba(2,132,199,0.12)',
				fill: true,
				tension: 0.35,
				pointRadius: 3,
				pointHoverRadius: 5,
			},
			{
				label: 'Tính lương',
				data: data?.plus || [],
				borderColor: '#f59e0b',
				backgroundColor: 'rgba(245,158,11,0.10)',
				fill: true,
				tension: 0.35,
				pointRadius: 3,
				pointHoverRadius: 5,
			},
		],
	};

	const options = {
		responsive: true,
		maintainAspectRatio: false,
		interaction: {mode: 'index', intersect: false},
		plugins: {
			legend: {position: 'top', labels: {boxWidth: 12, font: {size: 11}}},
			tooltip: {
				callbacks: {
					label: (ctx) => `${ctx.dataset.label}: ${numberFormat(ctx.parsed.y)}`,
				},
			},
		},
		scales: {
			y: {
				ticks: {
					font: {size: 10},
					callback: (value) => numberFormat(value),
				},
				grid: {color: '#f1f5f9'},
			},
			x: {
				ticks: {font: {size: 10}},
				grid: {display: false},
			},
		},
	};

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(2,132,199,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader icon="fa-light fa-chart-line" title={title} gradient={gradient} />
			<div style={{padding: '16px 18px', height: 300}}>
				{loading
					? <div style={{textAlign: 'center', color: '#94a3b8', fontSize: 13, paddingTop: 110}}>Đang tải...</div>
					: <Line data={chartData} options={options} />
				}
			</div>
		</div>
	);
}

export default memo(RevenueTrendChart);
